module.exports = __webpack_public_path__ + "img/logo-psiqueasy-store-light.1a62093c.png";